/* eslint-disable */
//tslint:disable

export interface IChatHintSchema {
  /** Ключ аналитики **/
  analyticsKey: EAnalyticsKey;
  /** Текст кнопки **/
  buttonText: string;
  /** Текст сообщения **/
  messageText: string;
}

export enum EAnalyticsKey {
  /** Есть предоплата? **/
  AdvancePayment = 'advancePayment',
  /** Свободные даты **/
  AvailableDates = 'availableDates',
  /** Кадастровый номер **/
  CadastralNumber = 'cadastralNumber',
  /** Можно с детьми? **/
  ChildrenOk = 'childrenOk',
  /** Свяжитесь со мной **/
  ContactMe = 'contactMe',
  /** Сколько за сутки? **/
  DailyPrice = 'dailyPrice',
  /** Дадите скидку? **/
  GiveDiscount = 'giveDiscount',
  /** Ещё сдаёте? **/
  IsActual = 'isActual',
  /** На месяц сдаёте? **/
  MonthlyRent = 'monthlyRent',
  /** Можно ещё фото? **/
  MorePhoto = 'morePhoto',
  /** Согласны на ипотеку? **/
  MortgageOk = 'mortgageOk',
  /** Можно с животными? **/
  PetsOk = 'petsOk',
  /** Ещё продаёте? **/
  StillSelling = 'stillSelling',
  /** Хочу посмотреть **/
  WhenSee = 'whenSee',
}
